import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    interval: { type: Number, default: 1500 },
    running: Boolean,
    url: String
  }

  connect() {
    this.timeoutId = null
    this.reloadQueued = false

    if (this.runningValue && this.hasUrlValue) {
      this.schedulePoll(250)
    }
  }

  disconnect() {
    this.clearPoll()
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue, {
        credentials: "same-origin",
        headers: {
          Accept: "application/json"
        }
      })

      if (!response.ok) throw new Error(`Backtest status request failed: ${response.status}`)

      const status = await response.json()
      this.applyStatus(status)

      if (status.terminal) {
        this.queueReload(status)
        return
      }
    } catch (_error) {
      // Keep polling; the next request can recover from a transient network or deploy blip.
    }

    this.schedulePoll()
  }

  applyStatus(status) {
    const runId = String(status.id)
    const percent = Math.min(parseFloat(status.progress_percent) || 0, 100)
    const progressLabel = status.progress_label || "Queued"
    const progressMessage = status.progress_total_requests > 0 ?
      `Processed ${status.progress_processed_requests} of ${status.progress_total_requests} shipping requests.` :
      "Waiting for the background job to start."

    document.querySelectorAll("[data-pick-lab-backtest-run-id]").forEach((root) => {
      if (root.dataset.pickLabBacktestRunId !== runId) return

      root.querySelectorAll("[data-pick-lab-backtest-status]").forEach((element) => {
        element.textContent = status.status_label
      })
      root.querySelectorAll("[data-pick-lab-backtest-progress]").forEach((element) => {
        element.textContent = progressLabel
      })
    })

    this.element.querySelectorAll("[data-pick-lab-backtest-progress-message]").forEach((element) => {
      element.textContent = progressMessage
    })
    this.element.querySelectorAll("[data-pick-lab-backtest-percent]").forEach((element) => {
      element.textContent = status.progress_percent_label
    })
    this.element.querySelectorAll("[data-pick-lab-backtest-stats-progress]").forEach((element) => {
      element.textContent = status.progress_percent_label
    })
    this.element.querySelectorAll("[data-pick-lab-backtest-bar]").forEach((element) => {
      element.style.width = `${percent}%`
    })
  }

  schedulePoll(delay = this.intervalValue) {
    this.clearPoll()
    this.timeoutId = window.setTimeout(() => this.poll(), delay)
  }

  clearPoll() {
    if (!this.timeoutId) return

    window.clearTimeout(this.timeoutId)
    this.timeoutId = null
  }

  queueReload(status) {
    if (this.reloadQueued) return

    this.reloadQueued = true
    this.clearPoll()
    window.setTimeout(() => {
      if (status.status !== "completed") {
        window.location.reload()
        return
      }

      const url = new URL(window.location.href)
      url.searchParams.set("completed_backtest_run_id", status.id)
      window.location.href = url.toString()
    }, 900)
  }
}
